/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef } from 'react';

import useOnClickOutside from '../../../../../hooks/useOnClickOutside';

export default function Player({ recordingUrl, close, buttonRef }) {
  const audioRef = useRef();

  useOnClickOutside(audioRef, close, buttonRef);

  return (
    <audio
      ref={audioRef}
      className="absolute z-20 left-[50%] top-[0] transform translate-x-[-50%] translate-y-[-110%]"
      controls
      src={recordingUrl}
      autoPlay
    />
  );
}
